import { ADMIN } from './index';
import { Action } from '../action';

export class AdminInitAction implements Action {
	readonly type = ADMIN.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminDestroyAction implements Action {
	readonly type = ADMIN.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminShowPageAction implements Action {
	readonly type = ADMIN.SHOW_PAGE;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}
